/**
 * Opens a constructed URL based on base URL, params, and query.
 * @param {Object} options
 * @param {string} options.url - Base URL (e.g. "/product" or "https://example.com")
 * @param {Array<string|number>} [options.params] - Path params (e.g., ["123", "details"])
 * @param {Object} [options.query] - Query params (e.g., { ref: "abc", page: 2 })
 * @param {string} [options.target="_blank"] - Where to open the link ("_blank", "_self", etc.)
 */
export function openLink({url, params = [], query = {}, target = "_blank"}) {
	if (!url) return;

	// Append path parameters
	const paramPath = params.length > 0 ? '/' + params.map(encodeURIComponent).join('/') : '';

	// Append query string
	const queryString = Object.keys(query).length > 0
		? '?' + new URLSearchParams(query).toString()
		: '';

	const finalUrl = `${url}${paramPath}${queryString}`;

	// Open the URL
	window.open(finalUrl, target);
}
